<template>
  <div id="chemtracker-sds-attachments-ui" class="chemtracker-module">
    <Stepper
      hide-stepper-controls
      :current-step="currentStep"
      :steps="getSteps()"
      :step-components="stepperStepsComponents"
      :step-labels="stepLabels"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import RAFTFullScreenContent from "../RAFTFullScreenContent.vue";
import Stepper from "../Stepper.vue";
import SdsAttachmentsFirstStep from "./chemtracker_sds/SdsAttachmentsFirstStep.vue";
import SdsAttachmentsSecondStep from "./chemtracker_sds/SdsAttachmentsSecondStep.vue";

const { mapActions } = createNamespacedHelpers("ChemtrackerSdsStore");

export default {
  name: "ChemicalContainerSdsAttachments",
  inject: ["contextNid"],
  data() {
    return {
      currentStep: 1,
      showSelections: true,
      showStepper: false,
      stepLabels: {},
      sdsSearchResults: [],
      stepperStepsComponents: [
        SdsAttachmentsFirstStep,
        SdsAttachmentsSecondStep,
      ],
    };
  },
  provide() {
    return {
      selectedContainerUuid: this.selectedChemicalContainerUuid,
      contextNid: this.contextNid,
    };
  },
  components: {
    RAFTFullScreenContent,
    Stepper,
  },
  computed: {
    selectedChemicalContainerUuid: function () {
      return this.selectedContainerUuid;
    },
  },
  props: {
    selectedContainerUuid: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions([]),
    getSteps: function () {
      return ["first", "second"];
    },
    reloadPage(event) {
      event.preventDefault();
      window.location.reload();
    },
  },
  created() {},
};
</script>

<style scoped></style>
